import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "spending-limit-chart" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "store-list" }
const _hoisted_5 = { class: "store-list-item-header" }
const _hoisted_6 = { class: "store-list-item-name" }
const _hoisted_7 = { class: "action" }
const _hoisted_8 = { class: "limit" }
const _hoisted_9 = { class: "limit-current" }
const _hoisted_10 = { class: "limit-total" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_LoadingTable = _resolveComponent("LoadingTable")!
  const _component_gs_alert_bar = _resolveComponent("gs-alert-bar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, [
        _createVNode(_component_v_icon, { size: 24 }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("mdi-finance")
          ])),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.t('title')), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.t('description')), 1)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoadingTable, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('billing_cycle')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userStores, (store) => {
              return (_openBlock(), _createElementBlock("div", {
                key: store.id,
                class: _normalizeClass(["store-list-item", { error: _ctx.isStoreActionNeeded(store) }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("strong", null, _toDisplayString(store.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, " $" + _toDisplayString(_ctx.formatNumberByLocale(store.spendingLimit?.used ?? 0)), 1),
                      _cache[1] || (_cache[1] = _createTextVNode(" / ")),
                      _createElementVNode("span", _hoisted_10, " $" + _toDisplayString(_ctx.formatNumberByLocale(store.spendingLimit?.activeLimit ?? 0)), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.editStore(store)),
                      class: "ml-2"
                    }, [
                      _createVNode(_component_v_icon, { size: 24 }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-pencil-outline")
                        ])),
                        _: 1
                      })
                    ], 8, _hoisted_11)
                  ])
                ]),
                (_ctx.isStoreActionNeeded(store))
                  ? (_openBlock(), _createBlock(_component_gs_alert_bar, {
                      key: 0,
                      onClick: ($event: any) => (store.spendingLimit?.pendingLimit ? _ctx.goToShopifyUrl(store) : _ctx.editStore(store)),
                      class: "mb-3",
                      type: "warning",
                      message: 
              !store.spendingLimit?.pendingLimit && !store.spendingLimit?.activeLimit
                ? _ctx.t('billing_blocked')
                : store.spendingLimit?.pendingLimit
                ? _ctx.t('approve_payment')
                : _ctx.t('update_limit')
            
                    }, null, 8, ["onClick", "message"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_progress_linear, {
                  class: "store-list-item-progress",
                  "bg-color": "beige",
                  color: _ctx.isStoreActionNeeded(store) ? '#ff2424' : '#47D18F',
                  rounded: "",
                  height: "29",
                  "model-value": _ctx.getProgressValue(store)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(Math.floor(_ctx.getProgressValue(store))) + "% ", 1)
                  ]),
                  _: 2
                }, 1032, ["color", "model-value"])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("p", _hoisted_12, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('limit_hit_email')), 1)
          ])
        ]))
  ]))
}